import { useCallback, useMemo, useState } from "react";

import { useAdminWorkflow } from "../../../../reactQuery/workflows";
import { formatWorkflowRows } from "../utils/workflowAdminUtils";
import {getResponseData} from "../../../../reactQuery/response";

export function useWorkflowTableState() {
  const [showEditWorkflow, setShowEditWorkflow] = useState(false);
  const [editWorkflowData, setEditWorkflowData] = useState(null);
  const [workflowId, setWorkflowId] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const [sortModel, setSortModel] = useState([{ field: "col1", sort: "asc" }]);
  const { adminWorkflows } = useAdminWorkflow();
  const data = useMemo(
    () => getResponseData(adminWorkflows,[]),
    [adminWorkflows]
  );

  const rows = useMemo(() => formatWorkflowRows(data), [data]);

  const handleEditWorkflowClose = useCallback(() => {
    setShowEditWorkflow(false);
  }, []);

  const handleEditWorkflow = useCallback((row, id) => {
    setWorkflowId(id);
    setEditWorkflowData(row);
    setShowEditWorkflow(true);
  }, []);

  const handleDeleteWorkflow = useCallback((id) => {
    setWorkflowId(id);
    setShowDelete(true);
  }, []);

  const handleDeleteClose = useCallback(() => {
    setShowDelete(false);
  }, []);

  return {
    rows,
    showEditWorkflow,
    editWorkflowData,
    workflowId,
    showDelete,
    sortModel,
    setSortModel,
    handleEditWorkflowClose,
    handleEditWorkflow,
    handleDeleteWorkflow,
    handleDeleteClose,
  };
}
